import { Grid } from '@mui/material'
import { useContext } from 'react'

import { CenteredLoading, Page } from '../../components'
import {
  AppointmentCalendar,
  AppointmentContainer
} from '../../components/Appointments'
import { NewAppointmentContext } from '../../providers'

export default function NewAppointmentPage() {
  const { isLoading } = useContext(NewAppointmentContext)
  return (
    <Page title="Manage Appointments">
      {isLoading ? (
        <CenteredLoading />
      ) : (
        <Grid container spacing={2}>
          <AppointmentCalendar />
          <AppointmentContainer data-testid="appointmentForm" />
        </Grid>
      )}
    </Page>
  )
}
